export default __webpack_public_path__ + "static/media/015-hot dog.1b7ddc65.svg";